import React from "react"
import { Breakpoint } from "react-socks"
import { PricingHeader } from "../typography"
import {
  PlanHeader,
  DropdownButton,
  PricingHeaderLeft,
  PlanButton,
  TitleHeader,
} from "./styled"
import PriceComponent from "./priceComponent"
import { ReactComponent as Dropdown } from "../../images/dropdown.svg"

const HeaderContainer = ({
  plan,
  onClick,
  opened,
  shouldOpenable,
  priceStep,
  link,
  periods,
}) => {
  const { button, slug, title, storage, sub, price, discount } = plan

  return (
    <PlanHeader onClick={onClick}>
      <TitleHeader
        direction="vertical"
        valign="center"
        shouldOpenable
      >
        <PricingHeader>{title}</PricingHeader>
        <Breakpoint mobile down>
          <PriceComponent
            price={price && price[priceStep]}
            discount={discount}
          />
        </Breakpoint>
      </TitleHeader>
      <Breakpoint tablet up>
        <PricingHeaderLeft>
          {storage}
          <div className="sub">{sub}</div>
        </PricingHeaderLeft>
      </Breakpoint>
      <Breakpoint mobile down>
        <PlanButton
          style={{ width: "100px" }}
          text={button.text}
          name={button.text}
          maxWidth="150px"
          slug={slug}
          icon="basket"
          to={
            button.to &&
            `${link}?plan=${button.to}&period=${periods[priceStep]}`
          }
        />
      </Breakpoint>
    </PlanHeader>
  )
}

export default HeaderContainer
